import { cn } from '@/lib/utils'
import { useContrastedBackground } from 'app/frontend/base/components/Card'

type Props = {
  details?: wowaudit.CharacterDetails
  compact?: boolean
  className?: string
}

const ItemLevelBadge = ({ details, compact, className }: Props) => {
  const background = useContrastedBackground()

  return (
    <div
      className={cn(
        'border rounded-lg flex gap-1 transition-opacity duration-300 items-center',
        background,
        compact ? 'px-1.5' : 'px-2',
        details?.maxItemLevel ? 'visible opacity-100' : 'invisible opacity-0',
        className,
      )}
    >
      {compact ? null : (
        <span className='text-muted-foreground text-[10px] font-semibold'>
          ilvl
        </span>
      )}

      <span
        className={cn('leading-tight', compact ? 'text-[10px]' : 'text-xs')}
      >
        {details?.maxItemLevel ?? '???'}
      </span>
    </div>
  )
}

export default ItemLevelBadge
